import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import React from 'react';

type Props = {
  inputRef: React.RefObject<HTMLInputElement | null>;
  urlLink: string;
  disabled?: boolean;
  placeholder: string;
  saveLabel: string;
  helperText: string;
  onSave: () => void;
};

export function DataUploadUrlSection({
  inputRef,
  urlLink,
  disabled,
  placeholder,
  saveLabel,
  helperText,
  onSave,
}: Props) {
  return (
    <>
      <Stack direction='row' alignItems='center' gap='10px'>
        <TextField
          inputRef={inputRef}
          sx={{ width: '350px' }}
          label={urlLink}
          variant='outlined'
          placeholder={placeholder}
        />
        <Button disabled={disabled} onClick={onSave} variant='primary' size='small'>
          {saveLabel}
        </Button>
      </Stack>
      <Box maxWidth='550px' mt='5px' mb='20px'>
        <Typography variant='subtitle3' color='textSecondary'>
          {helperText}
        </Typography>
      </Box>
    </>
  );
}
